import palette from '../palette';

const MuiAccordionDetails = {
  styleOverrides: {
    root: {
      '@media (max-width: 1024px)': {
        padding: 16,
      },
      backgroundColor: palette.surface.light,
      padding: 24,
    },
  },
};

export default MuiAccordionDetails;
